import React from "react";
import "./common.css";

const Insta = () => {
  return (
    <div className="insta-root">
      <div className="insta-card">
        {/* Header */}
        <div className="insta-header">
          <div className="insta-badge">Instant Pot • BOGO</div>
          <h1 className="insta-title">
            🍲 Cheesy Potato & Veggie Soup
          </h1>
          <p className="insta-subtitle">
            BOGO-powered comfort meal using your Publix deals.
          </p>
        </div>

        {/* BOGO deals section */}
        <div className="insta-section insta-deals">
          <h2 className="insta-section-title">BOGO Deals Used</h2>
          <ul className="insta-chip-list">
            <li className="insta-chip">Ore-Ida Potatoes</li>
            <li className="insta-chip">Birds Eye Vegetables</li>
            <li className="insta-chip">Swanson Broth</li>
            <li className="insta-chip">Cabot / Kraft Shredded Cheese</li>
            <li className="insta-chip">Daisy Sour Cream (optional)</li>
            <li className="insta-chip">Hormel / Oscar Mayer Bacon (optional)</li>
            <li className="insta-chip">Land O’ Lakes Butter</li>
            <li className="insta-chip">La Banderita Tortillas / Pillsbury Rolls</li>
          </ul>
        </div>

        {/* Ingredients */}
        <div className="insta-section">
          <h2 className="insta-section-title">⭐ Ingredients</h2>
          <ul className="insta-list">
            <li>3 cups <strong>Ore-Ida Potatoes</strong> (diced style works best)</li>
            <li>2 cups <strong>Birds Eye Vegetables</strong> (mixed veggies or broccoli)</li>
            <li>2 cups <strong>Swanson Broth</strong> (chicken or vegetable)</li>
            <li>1 cup <strong>Shredded Cheese</strong> (Cabot or Kraft)</li>
            <li>2 tbsp <strong>Butter</strong> (Land O’ Lakes)</li>
            <li>¼ cup <strong>Daisy Sour Cream</strong> (optional, extra creaminess)</li>
            <li>
              Optional toppings: <strong>Bacon bits</strong> using Hormel / Oscar Mayer bacon
            </li>
          </ul>
        </div>

        {/* Steps */}
        <div className="insta-section">
          <h2 className="insta-section-title">⏱ Instant Pot Instructions</h2>

          <div className="insta-step">
            <div className="insta-step-number">1</div>
            <div className="insta-step-body">
              <h3>Sauté base (3 min)</h3>
              <p>
                Set Instant Pot to <strong>Sauté</strong>.  
                Add <strong>2 tbsp butter</strong> and let it melt.
              </p>
            </div>
          </div>

          <div className="insta-step">
            <div className="insta-step-number">2</div>
            <div className="insta-step-body">
              <h3>Add veggies & potatoes</h3>
              <p>
                Add <strong>Ore-Ida potatoes</strong> and{" "}
                <strong>Birds Eye vegetables</strong>.  
                Stir for <strong>1 minute</strong>.
              </p>
            </div>
          </div>

          <div className="insta-step">
            <div className="insta-step-number">3</div>
            <div className="insta-step-body">
              <h3>Add broth & pressure cook</h3>
              <p>
                Pour in <strong>2 cups Swanson broth</strong>.  
                Close lid → set to <strong>Pressure Cook (High)</strong> →{" "}
                <strong>8 minutes</strong>.
              </p>
            </div>
          </div>

          <div className="insta-step">
            <div className="insta-step-number">4</div>
            <div className="insta-step-body">
              <h3>Quick release & make it cheesy</h3>
              <p>
                Perform <strong>Quick Release</strong>.  
                Switch to <strong>Sauté (Low)</strong>. Stir in{" "}
                <strong>1 cup shredded cheese</strong> and{" "}
                <strong>¼ cup sour cream</strong> (optional).  
                Cook <strong>2–3 minutes</strong> until melted and creamy.
              </p>
            </div>
          </div>

          <div className="insta-step">
            <div className="insta-step-number">5</div>
            <div className="insta-step-body">
              <h3>Top & serve</h3>
              <p>
                Top with extra <strong>shredded cheese</strong> and{" "}
                <strong>crumbled bacon</strong> (optional).  
                Serve with <strong>La Banderita Flour Tortillas</strong> or{" "}
                <strong>Pillsbury Crescent Rolls</strong> (both BOGO!).
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="insta-footer">
          <p className="insta-footer-text">
            Built with <span>🧠</span> Xpenze · Turn BOGOs into full meals.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Insta;
